module.exports = __webpack_public_path__ + "static/media/c3bcd90e-ec66-4373-8965-bb09c268c09c.7e8a5fc6.mp4";